import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import {
  createShopSeoDescription,
  updateShopSeoDescription,
} from 'actions/views/shops'
import useAction from 'utils/useAction'
import { Spin } from 'antd'
import { Field, Form } from 'react-final-form'
import Input from 'components/Input/Input'
import TextArea from 'components/TextArea/TextArea'
import { required } from 'helpers/validators'
import { StyledButton, StyledForm } from './ShopSeoDescription.styles'
import {
  getIsSavingActive,
  getShopSeoDescriptionsById,
} from 'domains/shops/selectors'

const autoSize = { minRows: 3, maxRows: 6 }

const ShopSeoDescription = ({ id, closeModal }) => {
  const isSavingActive = useSelector(getIsSavingActive)
  const seoDescription = useSelector(getShopSeoDescriptionsById)(id)
  const initialValues = seoDescription?.attributes || {}

  const createShopSeoDescriptionFunc = useAction(createShopSeoDescription)
  const updateShopSeoDescriptionFunc = useAction(updateShopSeoDescription)

  const onSubmit = (data) => {
    const values = {
      id: id,
      title: data.title,
      description: data.description,
      image_url: data.image_url,
      order_value: data.order_value,
    }

    if (id) {
      updateShopSeoDescriptionFunc({ values, callback: closeModal })
    } else {
      createShopSeoDescriptionFunc({ values, callback: closeModal })
    }
  }

  return (
    <Form
      destroyOnUnregister
      onSubmit={onSubmit}
      initialValues={
        id
          ? { ...initialValues, id }
          : {
              title: '',
              description: '',
              image_url: '',
              order_value: '',
            }
      }
      render={({ handleSubmit, pristine }) => {
        return (
          <Spin spinning={isSavingActive} size="large">
            <StyledForm onSubmit={handleSubmit}>
              {id && (
                <Field name="id" label="ID" disabled component={Input} />
              )}
              <Field
                required
                name="title"
                validate={required}
                label="Title"
                placeholder="SEO Title"
                component={Input}
              />
              <Field
                required
                name="description"
                validate={required}
                label="Description"
                placeholder="SEO Description"
                component={TextArea}
                autoSize={autoSize}
              />
              <Field
                required
                name="image_url"
                validate={required}
                label="Image URL"
                placeholder="Image URL or icon string"
                component={Input}
              />
              <Field
                name="order_value"
                label="Order Value"
                placeholder="Order Value"
                component={Input}
                type="number"
              />
              <StyledButton
                type="primary"
                disabled={pristine}
                onClick={handleSubmit}
              >
                Save changes
              </StyledButton>
            </StyledForm>
          </Spin>
        )
      }}
    />
  )
}

ShopSeoDescription.propTypes = {
  id: PropTypes.number,
  closeModal: PropTypes.func.isRequired,
}

ShopSeoDescription.defaultProps = {
  id: null,
}

export default ShopSeoDescription
